import { createUserManager } from "redux-oidc"
import { USERMANAGERCONFIG } from "../constants"

const userManagerConfig = {
  authority: USERMANAGERCONFIG.authority,
  client_id: "TTReportingFrontEnd",
  redirect_uri: USERMANAGERCONFIG.redirect_uri,
  response_type: "id_token token",
  scope: "openid TTAppIdentity TTReportingApi",
  post_logout_redirect_uri: USERMANAGERCONFIG.post_logout_redirect_uri,
  silent_redirect_uri: USERMANAGERCONFIG.silent_redirect_uri,
  automaticSilentRenew: true,
  filterProtocolClaims: true,
  loadUserInfo: true,
  prompt: "none",
}

const userManager = createUserManager(userManagerConfig)

export default userManager



// WEBPACK FOOTER //
// ./src/utils/user-manager.js